import React, { Component } from "react";
import "./Undo.scss";
import undoIcon from "./img/undo-modal-icon.svg";

export class Undo extends Component {

  noClicked = () => {
    this.props.showModal(false);
  };

  yesClicked = () => {
    if (this.props.restarts > 0 && Object.keys(this.props.snapshots).length > 0) {

      if(this.props.snapshots.hasOwnProperty('back2')){
        this.props.undo({
          lastState: this.props.snapshots.back2
        });
      } else {
        this.props.undo({
          lastState: this.props.snapshots.back1
        });
      }
      //console.log('UNDO >>>>', this.props.snapshots.back2);
    } else {
      //console.log("WARNING: No more undo attempts left.");
    }

    this.props.showModal(false);
  };

  render() {
    return (
      <div className="modal-section undo">
        <img alt="Undo Icon" src={undoIcon} className="undoModalIcon" />
        <h4 className="restartModalHeading">
          Are you sure you want to undo this step?
        </h4>
        <p className="restartsLeftText">{this.props.restarts} restarts left</p>
        <div className="modal-footer">
          <button
            aria-label="Start simulation button"
            tabIndex={this.props.tab}
            className="modal-btn-secondary lvl-choice"
            onClick={this.noClicked}
          >
            No
          </button>
          <button
            aria-label="Start simulation button"
            tabIndex={this.props.tab}
            className="modal-btn-primary lvl-choice"
            onClick={this.yesClicked}
          >
            Yes
          </button>
        </div>
      </div>
    );
  }
}
